// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"631":"c2162a5f","934":"ca46700b"}[chunkId] + ".chunk.css";
};